import { Layout, Typography, Row, Col, Breadcrumb } from "antd";
import { Link } from "react-router-dom";
import RequestAccessModal from "../components/RequestAccessModal";
import DeliverableCard from "../components/DeliverableCard";
import { useState } from "react";
import { CustomFooter } from "../components/Footer";
import HeroSection from "../components/HeroSection";

// Import JSON data
import deliverablesData from "../data/deliverables.json";
import LogoHeader from "../components/LogoHeader";

const { Content } = Layout;
const { Title, Paragraph } = Typography;

export default function DeliverablesPage() {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalContext, setModalContext] = useState({
    accessType: "full",
    deliverableName: null,
  });
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);

  const showModal = (context) => {
    setModalContext(
      context && context.deliverableName
        ? { accessType: "deliverable", deliverableName: context.deliverableName }
        : { accessType: "full", deliverableName: null }
    );
    setIsModalVisible(true);
  };

  const handleModalCancel = () => {
    setIsModalVisible(false);
  };

  const performSearch = (searchValue) => {
    if (!searchValue.trim()) {
      setSearchTerm("");
      setSearchResults([]);
      return;
    }

    const searchLower = searchValue.toLowerCase();
    const filteredDeliverables = deliverablesData.filter(
      (deliverable) =>
        deliverable.title.toLowerCase().includes(searchLower) ||
        deliverable.description.toLowerCase().includes(searchLower)
    );

    setSearchTerm(searchValue);
    setSearchResults(filteredDeliverables);
  };

  const onSearch = (value) => {
    performSearch(value);
  };

  // Type the imported data
  const deliverables = deliverablesData;

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <LogoHeader />

      <Content style={{ padding: "48px 0", backgroundColor: "#fff" }}>
        <div
          style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 24px" }}
        >
          <Breadcrumb
            style={{ marginBottom: "12px" }}
            items={[
              {
                title: <Link to="/">Trust Center</Link>,
              },
              {
                title: "Deliverables",
              },
            ]}
          />

          <HeroSection
            title="Deliverables"
            onRequestAccess={showModal}
            onSearch={onSearch}
          />

          {searchTerm ? (
            // Search Results Section
            <section style={{ marginBottom: "64px" }}>
              <div
                style={{
                  marginBottom: "8px",
                  paddingTop: "1px",
                }}
              >
                <Title level={2}>Search Results for "{searchTerm}"</Title>
                <Paragraph style={{ color: "#666", marginBottom: "24px" }}>
                  Found {searchResults.length} matching deliverable
                  {searchResults.length !== 1 ? "s" : ""}
                </Paragraph>

                <Row gutter={[24, 24]}>
                  {searchResults.map((deliverable, index) => (
                    <Col xs={24} md={8} key={index}>
                      <DeliverableCard
                        deliverable={deliverable}
                        onRequestAccess={(d) => showModal(d ? { deliverableName: d.title } : null)}
                      />
                    </Col>
                  ))}
                </Row>
              </div>
            </section>
          ) : (
            // Default Section
            <section style={{ marginBottom: "24px" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "8px",
                }}
              >
                <Title level={2}>FedRAMP</Title>
              </div>
              <Paragraph style={{ color: "#666", marginBottom: "24px" }}>
                The evidence packages that demonstrate pWin has implemented
                required controls and is maintaining compliance.
              </Paragraph>

              <Row gutter={[24, 24]}>
                {deliverables.map((deliverable, index) => (
                  <Col xs={24} md={8} key={index}>
                    <DeliverableCard
                      deliverable={deliverable}
                      onRequestAccess={(d) => showModal(d ? { deliverableName: d.title } : null)}
                    />
                  </Col>
                ))}
              </Row>
            </section>
          )}
        </div>
      </Content>

      <CustomFooter />

      <RequestAccessModal
        visible={isModalVisible}
        onCancel={handleModalCancel}
        accessType={modalContext.accessType}
        deliverableName={modalContext.deliverableName}
      />
    </Layout>
  );
}
